// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3659550778/src/~/core-js/library/modules/_to-integer.js
// module id = I5DZ
// module chunks = 6